import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MyContext } from "../../hooks/useContextProvider";

const Logout = () => {
  const navigate = useNavigate();
  const { token, updateToken, updateData } = useContext(MyContext);

  useEffect(() => {
    // if (token) {
      console.log("running");
      localStorage.clear();
      updateToken("");
      updateData({});
      navigate("/");
    // }
  }, [navigate]);

  return null;
};

Logout.propTypes = {
  // No props needed for React Router v6
};

export default Logout;
